import { BodyOf } from "../../../core/api";
import { createMutationGroup } from "../../../core/api/mutations";
import { PatientId } from "../../../shared/schema/schema";
import { BulkScheduleTasksBody } from "./bulk-schedule-tasks.types";

export default createMutationGroup(({ api, createMutation }) => ({
  bulkScheduleTasks: () =>
    createMutation({
      mutationFn: (body: BulkScheduleTasksBody) =>
        api.post("./patient_tasks/bulk_schedule", { body }),
    }),

  createCertificationPeriod: (patientId: PatientId) =>
    createMutation({
      mutationFn: (body: BodyOf<"post", "./patients/:patientId/certification_periods">) =>
        api.post("./patients/:patientId/certification_periods", {
          path: { patientId },
          body,
        }),
    }),
}));
